export default __webpack_public_path__ + "static/media/sports2.a4b00326.jpg";